import type { HelpStateItem } from '../interfaces';
import { API } from '@Providers';

export default async function (payload: HelpStateItem) {
  const endpoint = '/api/shelter/help-state';

  return API({ endpoint, method: 'post', payload });
}
